export const getFileNameFromDate = (
  dateString: string,
  id: string,
  extension: string
) => {
  const dateName = dateString.replaceAll(':', '_')
  const fileNameSplit = dateName.replaceAll('.', '_')
  return `${fileNameSplit}-${id}.${extension}`
}

export const getFileNameFromDateV2 = (dateString: string, fileName: string) => {
  const dateName = dateString.replaceAll(':', '_')
  const fileNameSplit = dateName.replaceAll('.', '_')
  return `${fileNameSplit}-file-${fileName?.replaceAll(' ', '-')}`
}
